import Box from 'components/shared/Box'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import BusTicketCreator from 'routes/Upsell/BusTicketCreator'
import BusTicket from './tickets/BusTicket'
import { TransportReservation } from 'store/selfcare-slice/types'

interface ManageBusTicketsProps {
    transport: TransportReservation[]
}

const ManageBusTickets = ({ transport }: ManageBusTicketsProps) => (
    <Section id="manage-transport" hasSmallerSpacingsX hasSmallerSpacingsY>
        <Text variant="heading3" color="grayscale_900" mb={[24, 32]}>
            <FormattedMessage
                id="selfcare.transport.section_caption"
                defaultMessage="Suntago Bus"
            />
        </Text>
        <Box gap={[16, 24]} isFullWidth>
            {transport.map((ticket, index) => (
                <BusTicket
                    key={ticket.original.detail.orderTransportTicketId}
                    ticket={ticket}
                    index={index}
                />
            ))}
            <BusTicketCreator hasAltEditMode />
        </Box>
    </Section>
)

export default ManageBusTickets
